var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React, { useState } from "react";
import ReactStars from "react-rating-stars-component";
import { Grid, Typography, Icon } from "../../components";
import { COLOR } from "../../theme/constants";
import { InfoBox } from "./ContactFormSuccess.styled";

var ContactFormSuccess = function ContactFormSuccess(_a) {
  var _b = _a.onSubmit,
      onSubmit = _b === void 0 ? function () {
    return null;
  } : _b,
      _c = _a.link,
      link = _c === void 0 ? "#" : _c,
      _d = _a.isWithRating,
      isWithRating = _d === void 0 ? true : _d,
      props = __rest(_a, ["onSubmit", "link", "isWithRating"]);

  var _e = useState(false),
      isSend = _e[0],
      setSend = _e[1];

  return React.createElement(Grid.Container, __assign({
    fluid: true,
    background: COLOR.brandGreen,
    color: COLOR.white
  }, props, {
    py: 65
  }), React.createElement(Grid.Container, null, React.createElement(Grid.Row, null, React.createElement(Grid.Col, {
    xs: 12
  }, React.createElement(InfoBox, null, React.createElement(Icon, {
    name: "Info",
    size: "1.5rem",
    ml: 2,
    mr: 3
  }), React.createElement(Typography, {
    my: 0,
    fontSize: "0.875rem"
  }, "Chcesz dowiedzie\u0107 si\u0119 wi\u0119cej o mo\u017Cliwo\u015Bciach finansowania potrzeb zwi\u0105zanych z prowadzon\u0105 produkcj\u0105 rolnicz\u0105", React.createElement("a", {
    href: link
  }, "Czytaj wi\u0119cej"))), React.createElement(Typography, {
    variant: "h2",
    isUpperCase: true,
    color: "white",
    textAlign: "center"
  }, "Dzi\u0119kujemy za kontakt"), React.createElement(Grid.Box, {
    maxWidth: 400,
    margin: "1.5rem auto 2.625rem auto"
  }, React.createElement(Typography, {
    color: "white",
    textAlign: "center"
  }, "Dzi\u0119kujemy za wype\u0142nienie formularza. Nasz konsultant skontakuje si\u0119 najszybciej jak to b\u0119dzie mo\u017Cliwe")), isWithRating ? isSend ? React.createElement(Grid.Box, {
    maxWidth: 400,
    margin: "0 auto"
  }, React.createElement(Typography, {
    color: "white",
    textAlign: "center",
    fontWeight: 700
  }, "Dzi\u0119kujemy za przes\u0142anie opinii.")) : React.createElement(React.Fragment, null, React.createElement(Grid.Box, {
    maxWidth: 400,
    margin: "0 auto"
  }, React.createElement(Typography, {
    color: "white",
    textAlign: "center",
    fontWeight: 700
  }, "Jak oceniasz dopasowanie produktu do twoich potrzeb?")), React.createElement(Grid.Box, {
    display: "flex",
    justifyContent: "center"
  }, React.createElement(ReactStars, {
    count: 5,
    onChange: function onChange(newValue) {
      if (!isSend) {
        setSend(true);
        onSubmit(newValue);
      }
    },
    size: 45,
    activeColor: COLOR.brandOrange,
    color: COLOR.white
  }))) : null))));
};

export default ContactFormSuccess;